import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

const colors = ['#4A90E2', '#E94E77', '#50E3C2', '#F5A623', '#9013FE'];

const legend = [
  'Cool Out',
  'Rack Inlet Temp',
  'Supply Air High Temp',
  'Entering Fluid Temp',
  'Leaving Fluid Temp',
];
// todo check lại điều kiện lấy các chỉ số => dựa theo key ko dựa theo index
export const LineChart = ({
  label = ['1', '2', '3', '4', '5', '6', '7', '8'],
  data,
  width = '400px',
  height = '200px',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const formatToSeries = (data, colors, names) => {
    return legend?.map((item, index) => ({
      name: item, // Gán tên từ mảng mới
      type: 'line',
      data: data?.map((item) => item[index]),
      lineStyle: {
        color: colors[index % colors.length], // Gán màu từ mảng màu
        width: 2,
      },
      symbol: 'circle',
      symbolSize: 6,
      itemStyle: {
        color: colors[index % colors.length], // Áp dụng màu cho symbol
      },
    }));
  };

  // Gọi hàm và lưu kết quả
  const formattedSeries = formatToSeries(data, colors, legend);

  const options = {
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: legend,
      top: '85%', // Dịch legend xuống sát cuối
      left: 'center', // Căn giữa
      orient: 'horizontal', // Hiển thị theo hàng ngang
      itemWidth: 10, // Chiều rộng biểu tượng
      itemHeight: 10, // Chiều cao biểu tượng
      textStyle: {
        fontSize: 9, // Giảm kích thước chữ
        color: isAdminRoute,
      },
      padding: [0, 10], // Tùy chỉnh khoảng cách
    },
    grid: {
      left: '7%',
      right: '0%',
      top: '15%',
      bottom: '25%', // Tăng khoảng trống phía dưới để legend không bị chồng
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
      axisLabel: {
        fontSize: 12,
        rotate: 45,
        color: isAdminRoute,
      },
    },
    yAxis: {
      type: 'value',
      name: '°C',
      nameLocation: 'end',
      nameTextStyle: {
        fontSize: 14,
        padding: [0, 0, 0, -40],
      },
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
      axisLabel: {
        fontSize: 12,
      },
    },
    series: formattedSeries,
  };

  return (
    <ReactEcharts
      option={options}
      style={{ width: width, height: height }}
      onEvents={() => {}}
    ></ReactEcharts>
  );
};
